import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import {getJSON} from '../components/GlobalFunctions';

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import registration_0 from '../img/registr/registr-5.svg'

import registration_1 from '../img/registr/registr-1.svg'
import registration_2 from '../img/registr/registr-2.svg'
import registration_3 from '../img/registr/registr-3.svg'
import registration_4 from '../img/registr/registr-4.svg'

export default class Register extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			statusApi: false,
			statusAllow: false,
			statusQuota: false,
		};
	}

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var self = this, mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);

		getJSON('GET', '/api/register/allow', null, function(data){var dataArray=(typeof data==='string')?JSON.parse(data):data;
			self.setState({statusApi: true});
			if (dataArray.is_quota) {
				self.setState({statusQuota: true});
			}
			if (dataArray.is_person||dataArray.is_group) {
				self.setState({statusAllow: true});
			}
		}, function(status){});
	}

	render() {
		return (
			<div>

				<Helmet
					title="Registration is Сlosed - UvoCorp.com"
					meta={[
						{ name: "description", content: "Please, try to register once again tomorrow as today's quota on the number of applicants has been exceeded." }
					]}

					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/register_closed.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">

					<div className="inner-header">
						<div className="container">
							<h1>Registration</h1>
						</div>
					</div>

					<div className="inner-white inner-center">
						<div className="container">
							{this.state.statusApi? (
								<div className="col-sm-8">
									{!this.state.statusQuota&&this.state.statusAllow? (
										<div className="registr_text">
											<p>Dear Applicant,</p>
											<p>Thank you for your interest in our company.</p>
											<p>Please, try to register once again tomorrow as today&apos;s quota on the number of applicants has been exceeded.</p>
										</div>
									 ) : (
										<div>
											<h2 className="left">Registration of new writers is currently closed</h2>
											<p>Registration of new writers is currently closed.</p>
											<p>Please make sure to check our website for the updates and get back to us.</p>
											<p>If you have any questions through <a href="mailto:vacancy@uvocorp.com">vacancy@uvocorp.com</a>.</p>
										</div>
									 )}
								</div>
							) : (
								<div className="col-sm-8"></div>
							) }
							<div className="col-sm-4">
								<div className="registr_img registr_img_1">
									<img src={registration_0} alt="Registration Image1"/>
								</div>
							</div>
						</div>
					</div>

						<div className="inner-gray">
							<div className="container">
								<div className="col-md-push-5 col-md-7">
									<div className="hiring-alert hiring-alert-p">
										<div className="hiring-alert-title">Warning – do not buy uvocorp accounts</div>
										<div className="hiring-alert-text">
											<p>Dear applicants, please <strong>never buy a registered</strong> UVOCORP account that you may find in an online advertisement. You will pay money (sometimes as much as $500) and be able to write maximum one or two papers, since all accounts, especially the new ones, are constantly checked by our quality specialists. Sold accounts are closed upon disclosure, and the payments of such account owners are suspended. Better invest in your development as an academic writer with SIMBA school. Explore <a href="/simba.html">our page</a> for more information and take a step towards enhancing your skills.</p>
										</div>
									</div>
									<h2 className="inner-left">Registration Steps</h2>
									<ol className="registr-steps">
										<li>Provide us with your e-mail address.</li>
										<li>Create your profile using a special link sent to your e-mail and verify your phone number; <br />As a security measure, we require all our applicants to upload a photo of themselves holding their ID for identity proof. We respect your privacy and do not disclose your personal information to the third parties.</li>
										<li>Write a sample paper.</li>
									</ol>
									<p>After that we will check your profile and evaluate your sample. Usually it takes up to 4-7 business days for us to properly conduct those procedures. If your sample is approved, we will activate your writer’s account, and you will be able to start working. If not, you will have a chance to reapply in 3 months following the ‘reinstate account’ procedure by pressing the log-in button on the main page and inserting the log-in details used while registering previous time.</p>

									<p className="registr-alert">
										<strong>Remember:</strong> it is important to fill in the real information in your writer’s profile to avoid unnecessary delays and clarifications later on.
									</p>
								</div>
								<div className="col-md-pull-7 col-md-5">
									<div className="registr_img registr_img_1">
										<img src={registration_1} alt="Registration Image1"/>
									</div>
								</div>
							</div>
						</div>

						<div className="inner-white inner-center">
							<h2>Sample Paper</h2>
							<div className="container">
								<div className="col-sm-8">
									<p>In order to choose the best writers, we ask all applicants to write a 5-paragraph sample paper on an automatically selected topic. Each applicant has 3 hours to complete this step. Yet we provide detailed hints and pieces of advice before you start writing the paper, which eases the process.</p>
									<p>Generally speaking, we are looking for the writers who can properly express their thoughts and know how to support their stance. It is perfectly fine to make some mistakes; in such cases we will simply assign a professional editor to proofread your papers.</p>
								</div>
								<div className="col-sm-4">
									<div className="registr_img registr_img_2">
										<img src={registration_2} alt="Registration Image2"/>
									</div>
								</div>
							</div>
						</div>

						<div className="inner-gray inner-center inner-center-md">
							<h2>Initial Steps after Approval</h2>
							<div className="container">
								<div className="col-md-push-4 col-md-8">
									<p>All new writers (reinstated writers are considered to be new) undergo a probation period (unless otherwise notified by the Adaptation Specialist). The probation is aimed to ensure that our team is reinforced with only competent candidates. During this period, an applicant may be obliged to join the Mentoring Project or the Editing Program. If a writer is enrolled in the Editing Program, his or her papers will be checked and corrected by professional editors. If an applicant joins the Mentoring Program, he or she will work with a mentor, who will assign orders to the writer and then edit them. The probation period will end with either the account closure (if the writer fails to show good quality standards) or graduation from the Mentoring Program. <strong>The aim of both the Editing and Mentoring Programs is to ensure that each new writer passes the onboarding process with the help of more experienced writers and smoothly flows into the work.</strong></p>
									<p>All the writers that have failed the probation period have a chance to reapply in 6 months. They only need to follow the ‘reinstate account’ procedure by pressing the log-in button on the main page and inserting the log-in details used while registering previous time.</p>
								</div>
								<div className="col-md-pull-8 col-md-4">
									<div className="registr_img registr_img_3">
										<img src={registration_3} alt="Registration Image3"/>
									</div>
								</div>
							</div>
						</div>

						<div className="inner-white registr-float_img">
							<h2>Working As a Team of Writers</h2>
							<div className="container">
								<div className="col-sm-6 col-md-7 col-lg-8">
									<p>If you decide to submit the papers completed the help of other individuals, you have to inform us about it. The word “Group” will then be added to your name, which will help us avoid confusion during the quality checks of your account and choose appropriate candidates for various promotion opportunities. Mind that you will remain responsible for the quality of your papers but will face no penalties for having a group account.</p>
								</div>
								<div className="col-sm-6 col-md-5 col-lg-4">
									<div className="registr_img registr_img_4">
										<img src={registration_4} alt="Registration Image4"/>
									</div>
								</div>
							</div>
						</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/register_closed.html.js